//YOUHELPER
    exports.getSPAJHeader = '/helper/v2/customer/get-spaj-header' //
    exports.otpGenerate = '/helper/v2/customer/generate-otp' //
    exports.otpLogin = '/helper/v2/customer/login' //
    exports.getParameter = '/helper/v2/customer/get-parameter-apps' //
    exports.LogOut = '/helper/v2/customer/logout'
    exports.otpVerif = '/helper/v2/customer/verify-otp'
    exports.getCitySign = '/helper/v2/customer/get-city-sign' //

//YOUEAPP
//1. GET DETAIL SPAJ & DOCUMENT & REVISI & UPDATE STATUS
    exports.getDetailSPAJ = '/eapp/v2/customer/get-spaj-detail' //OK //DONE
    exports.illustrationSPAJ = '/eapp/v2/customer/get-document' //OK //DONE
    exports.updateStatusSPAJ = '/eapp/v2/customer/update-status-spaj' //OK //DONE

//2. GET & SUBMIT - SELFIE & SIGNATURE
    exports.getSignature = '/eapp/v2/customer/get-sign-list' //OK //DONE
    exports.getSelfie = '/eapp/v2/customer/get-selfie-list' //OK //DONE
    exports.insertSignature = '/eapp/v2/customer/insupd-signature' //OK //DONE
    exports.checkSelfieSignature = '/eapp/v2/customer/chk-sign-selfie' //OK //DONE

    //OCR
    exports.insertSelfie = '/ocr/v3/customer/validate-selfie-you' //OK

    // exports.getSingleSignature = '/eapp/customer/getSignature' //DELETE

//3. GET & INSERT - PEMBAYARAN
    exports.insUpdPaymentData = "/eapp/v2/customer/insupd-payment-data" //insupd-payment-data
    exports.updatePaymentCC = "/eapp/v2/customer/update-payment-cc" //update-payment-cc
    exports.updatePaymentAdol = "/eapp/v2/customer/update-payment-adol" //update-payment-adol
    exports.getOfflinePayment = "/eapp/v2/customer/get-va-payment" //get-va-payment
    exports.getPaymentData = "/eapp/v2/customer/get-payment-data" //get-payment-data
    exports.changePaymentVa = "/eapp/v2/customer/change-payment-va" //change-payment-va
    exports.checkStatusPayment ="/eapp/v2/customer/check-payment"

//4. GET & SUBMIT - VIDEO PERNYATAAN
    exports.getStatement = '/eapp/v2/customer/get-pernyataan-script' //OK //DONE
    exports.getProductScript = '/eapp/v2/customer/get-product-script' //OK //DONE
    exports.getVideo = '/eapp/v2/customer/get-data-vid-pernyataan' //OK //DONE
    exports.getVideoPending = '/eapp/v2/customer/get-data-vid-pernyataan-pending' //OK //DONE
    exports.updatePreambule = '/eapp/v2/customer/update-preambule' //OK //DONE
    exports.convertVideo = '/vidconvert/create3' //OK
    exports.saveAnswer = '/vidconvert/saveAnswer' //OK

    // exports.insertVideo = '/eapp/customer/v2/vidPernyataan' //DELETE

//5. GET & SUBMIT - SPAJ
    exports.checkValidasi = '/eapp/v2/customer/chkvalidation-submit-spaj-new' //OK //DONE
    exports.generateDocSubmit = '/eapp/v2/customer/generate-doc-submission' //OK //DONE
    exports.dmsIproposeSubmit = '/eapp/v2/customer/send-doc-dms-ipropose' //OK //DONE
    exports.submitBPM = '/eapp/v2/customer/eapp-submission-json' //OK
    // exports.submitBPM = '/eapp/customer/eappSubmission'//-json' //OK



    // exports.insertDokumen = '/eapp/customer/insUpdDocument' // DELETE
    // exports.checkSubmit = '/eapp/customer/eappSubmAndGenerateDoc'
    // exports.submitBPM = '/eapp/customer/eappSubmission'
    // exports.submitBPMFu = '/eapp/customer/eappSubmissionFu'

//6. GET & SUBMIT - SUSULAN
    exports.getPendingDocument = '/eapp/v2/customer/get-pending-document' //OK //DONE
    exports.rejectVidPernyataan = '/eapp/v2/customer/reject-vid-pernyataan' //OK //DONE
    exports.rejectPendingDoc = '/eapp/v2/customer/reject-pending-doc' //OK //DONE
    exports.submitBPMFu = '/eapp/v2/customer/eapp-submissionfu-json' //OK
    // exports.submitBPMFu = '/eapp/customer/eappSubmissionFu'//-json' //OK


//PAYMENT HUB
    exports.paymentTokenRequest = 'paymentTokenRequest'
    exports.getStatusInquiry = 'gopay/v2/info/get?paymentToken='
    exports.checkStatusByToken = 'midtrans/checkstatusbytoken?tokenPayment='